import { Module } from 'vuex'
import { RootState, DocState } from '../storeTypes'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state: DocState = {
  docId: '',
  docState: 'notexists',
  docOrdered: false,
  stageDescription: undefined,
  userDocs: []
}

export const doc: Module<DocState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
